import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));


  declare global {
    interface Date {
        addDays(days: number): Date;
        addWeeks(weeks: number): Date;
        addMonths(months: number): Date;
        addYears(years: number): Date;
    }
}

Date.prototype.addDays = function (days: number): Date {
    const date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
};

Date.prototype.addWeeks = function (weeks: number): Date {
    const date = new Date(this.valueOf());
    date.setDate(date.getDate() + weeks * 7);
    return date;
};

Date.prototype.addMonths = function (months: number): Date {
    const date = new Date(this.valueOf());
    date.setMonth(date.getMonth() + months);
    return date;
};

Date.prototype.addYears = function (years: number): Date {
    const date = new Date(this.valueOf());
    date.setFullYear(date.getFullYear() + years);
    return date;
};